import Vue__default from "vue";
import TUINotification from "./index.vue.mjs";
let notificationInstance = null;
let container = null;
let timer = null;
const Notification = ({
  message,
  confirm,
  cancel,
  confirmButtonText,
  cancelButtonText
}) => {
  const fullscreenElement = document.fullscreenElement || document.getElementById("roomContainer") || document.body;
  if (!notificationInstance) {
    container = document.createElement("div");
    fullscreenElement.appendChild(container);
  }
  const close = () => {
    if (vm) {
      vm.$destroy();
      if (container == null ? void 0 : container.parentNode) {
        container.parentNode.removeChild(container);
        notificationInstance = null;
      }
    }
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  const NotificationConstruct = Vue__default.extend({
    render: (h) => h(TUINotification, {
      props: {
        message,
        confirm,
        cancel,
        confirmButtonText,
        cancelButtonText,
        close
      }
    })
  });
  const vm = new NotificationConstruct({
    el: document.createElement("div")
  }).$mount();
  container == null ? void 0 : container.appendChild(vm.$el);
  notificationInstance = NotificationConstruct;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(close, 3e3);
  return {
    close
  };
};
export {
  Notification as default
};
